<section
  class="mbs-wizard_form"
  [formGroup]="stepForm">
  <div class="mbs-wizard_form-content">
    @if (hasAdvice) {
      <mbs-card
        class="mb-4"
        [customClasses]="'background-secondary'"
        [hasPadding]="false"
        [size]="MbsSize.xs">
        <div class="d-flex flex-column w-100 h-100 p-2">
          <div class="d-flex align-items-center">
            <span class="pr-2 {{ planType | planType: 'iconClass' }}"></span>
            <span class="fw-bold">{{ planType | planType: 'name' }}</span>
          </div>

          <div class="pt-2 pl-2">
            <ul class="mb-0">
              @for (str of descriptions[planType]; track $index) {
                <li>{{ str }}</li>
              }
            </ul>
          </div>

          <div class="mt-auto pl-3 pt-3">
            <span class="mr-2 fa fa-thumbs-o-up"></span><span>{{ bestForAdvices[planType] }}</span>
          </div>

          <a
            class="mt-1 pl-3"
            target="_blank"
            [helpLink]="currentHelpLink"
            [kbMode]="true"
            (click)="$event.stopPropagation()">
            {{ 'shared:buttons.learnMore' | i18next }}
          </a>
        </div>
      </mbs-card>
    } @else {
      <div class="text-center pb-4 mb-2">
        <img
          alt=""
          class="w-75"
          [src]="imageSrc" />
      </div>
    }

    @if (isRestore) {
      <mbs-form-group>
        <mbs-radio
          class="mb-3"
          formControlName="SavePlanInCloud"
          name="SaveBackupPlan"
          [descriptionClasses]="'mt-1'"
          [descriptionOutside]="false"
          [id]="'save-backup-plan-radio-0'"
          [label]="'wizards:run_restore_once' | i18next"
          [ngClass]="elementsSelector.css.planNameRestoreRadio"
          [value]="false"
          (change)="changeSavePlanHandler($event)">
          <ng-template radioDescription>
            @for (item of runRestoreOnceSubtitle; track $index; let last = $last) {
              <span class="text-xs">
                {{ item }}
                @if (!last) {
                  <br />
                }
              </span>
            }
          </ng-template>
        </mbs-radio>
        <mbs-radio
          formControlName="SavePlanInCloud"
          name="SaveBackupPlan"
          [descriptionClasses]="'text-xs mt-1'"
          [descriptionOutside]="false"
          [disabledSelf]="disableSaveRestorePlan"
          [id]="'save-backup-plan-radio-1'"
          [label]="'wizards:save_restore_plan' | i18next"
          [ngClass]="elementsSelector.css.planNameRestoreRadio"
          [value]="true"
          (change)="changeSavePlanHandler($event)">
          <ng-template radioDescription>
            <div class="text-xs mb-3">{{ 'wizards:save_restore_plan_desc' | i18next }}</div>
            <mbs-input
              formControlName="Name"
              name="planName"
              [id]="'planName'"
              [label]="'wizards:plan_name' | i18next"
              [placeholder]="'wizards:plan_name_placeholder' | i18next"
              [validationWhitespace]="true"></mbs-input>
          </ng-template>
        </mbs-radio>
      </mbs-form-group>
    } @else {
      <ng-container>
        <mbs-form-group>
          <mbs-input
            formControlName="Name"
            name="planName"
            [id]="'planName'"
            [label]="'wizards:plan_name' | i18next"
            [placeholder]="'wizards:plan_name_placeholder' | i18next"
            [validationWhitespace]="true"></mbs-input>
        </mbs-form-group>

        @if (!isNBF) {
          <ng-container>
            <mbs-form-group>
              <mbs-checkbox
                formControlName="SavePlanInCloud"
                [id]="'saveToStorage'"
                [label]="'wizards:save_to_storage' | i18next"
                [ngClass]="elementsSelector.css.planNameBackupCheckbox"></mbs-checkbox>
            </mbs-form-group>

            <mbs-alert
              class="mb-0 mt-3"
              [icon]="true"
              [type]="mbsPopupType.info">
              {{ 'wizards:plan_name_alert' | i18next }}
            </mbs-alert>
          </ng-container>
        }
      </ng-container>
    }

    @if (!isProduction && !ability.can('read', 'AgentLocal')) {
      <div class="row mt-2">
        @if (!isRDMode) {
          <mbs-button
            class="col-auto"
            (click)="toggleABTest()">
            Toggle AB Test
          </mbs-button>
        }
        <mbs-button
          class="col"
          (click)="copyPlan.emit()">
          Copy RAW plan to Clipboard
        </mbs-button>
      </div>
    }
  </div>
</section>
